/* This file is generated by Kubb. DO NOT EDIT MANUALLY. */

import type { AcknowledgeIncidentPathParams, AcknowledgeIncidentMutationRequest } from './types/AcknowledgeIncident.ts';
import type { CreateMonitorMutationRequest } from './types/CreateMonitor.ts';
import type { DeleteMonitorPathParams } from './types/DeleteMonitor.ts';
import type { GetMonitorPathParams } from './types/GetMonitor.ts';
import type { GetMonitorStatsPathParams, GetMonitorStatsQueryParams } from './types/GetMonitorStats.ts';
import type { ListMonitorIncidentsPathParams, ListMonitorIncidentsQueryParams } from './types/ListMonitorIncidents.ts';
import type { PauseMonitorPathParams } from './types/PauseMonitor.ts';
import type { RecordHeartbeatPathParams } from './types/RecordHeartbeat.ts';
import type { RecordHeartbeatFailurePathParams, RecordHeartbeatFailureMutationRequest } from './types/RecordHeartbeatFailure.ts';
import type { RecordHeartbeatPostPathParams } from './types/RecordHeartbeatPost.ts';
import type { ResumeMonitorPathParams } from './types/ResumeMonitor.ts';
import type { RotateHeartbeatTokenPathParams } from './types/RotateHeartbeatToken.ts';
import type { SearchMonitorRequestLogsPathParams, SearchMonitorRequestLogsMutationRequest } from './types/SearchMonitorRequestLogs.ts';
import type { SearchMonitorsMutationRequest } from './types/SearchMonitors.ts';
import type { UpdateMonitorPathParams, UpdateMonitorMutationRequest } from './types/UpdateMonitor.ts';
import type { Client } from '@kubb/plugin-client/clients/fetch';
import { acknowledgeIncident } from './clients/acknowledgeIncident.ts';
import { createMonitor } from './clients/createMonitor.ts';
import { deleteMonitor } from './clients/deleteMonitor.ts';
import { getMonitor } from './clients/getMonitor.ts';
import { getMonitorStats } from './clients/getMonitorStats.ts';
import { listMonitorIncidents } from './clients/listMonitorIncidents.ts';
import { pauseMonitor } from './clients/pauseMonitor.ts';
import { recordHeartbeat } from './clients/recordHeartbeat.ts';
import { recordHeartbeatFailure } from './clients/recordHeartbeatFailure.ts';
import { recordHeartbeatPost } from './clients/recordHeartbeatPost.ts';
import { resumeMonitor } from './clients/resumeMonitor.ts';
import { rotateHeartbeatToken } from './clients/rotateHeartbeatToken.ts';
import { searchMonitorRequestLogs } from './clients/searchMonitorRequestLogs.ts';
import { searchMonitors } from './clients/searchMonitors.ts';
import { updateMonitor } from './clients/updateMonitor.ts';

export class ApiClient {
  constructor(private readonly client: Client) {}

  recordHeartbeat(token: RecordHeartbeatPathParams['token']) {
    return recordHeartbeat(token, { client: this.client });
  }
  recordHeartbeatPost(token: RecordHeartbeatPostPathParams['token']) {
    return recordHeartbeatPost(token, { client: this.client });
  }
  recordHeartbeatFailure(token: RecordHeartbeatFailurePathParams['token'], data?: RecordHeartbeatFailureMutationRequest) {
    return recordHeartbeatFailure(token, data, { client: this.client });
  }
  searchMonitors(data: SearchMonitorsMutationRequest) {
    return searchMonitors(data, { client: this.client });
  }
  createMonitor(data: CreateMonitorMutationRequest) {
    return createMonitor(data, { client: this.client });
  }
  getMonitor(id: GetMonitorPathParams['id']) {
    return getMonitor(id, { client: this.client });
  }
  updateMonitor(id: UpdateMonitorPathParams['id'], data: UpdateMonitorMutationRequest) {
    return updateMonitor(id, data, { client: this.client });
  }
  deleteMonitor(id: DeleteMonitorPathParams['id']) {
    return deleteMonitor(id, { client: this.client });
  }
  pauseMonitor(id: PauseMonitorPathParams['id']) {
    return pauseMonitor(id, { client: this.client });
  }
  resumeMonitor(id: ResumeMonitorPathParams['id']) {
    return resumeMonitor(id, { client: this.client });
  }
  rotateHeartbeatToken(id: RotateHeartbeatTokenPathParams['id']) {
    return rotateHeartbeatToken(id, { client: this.client });
  }
  listMonitorIncidents(id: ListMonitorIncidentsPathParams['id'], params?: ListMonitorIncidentsQueryParams) {
    return listMonitorIncidents(id, params, { client: this.client });
  }
  getMonitorStats(id: GetMonitorStatsPathParams['id'], params?: GetMonitorStatsQueryParams) {
    return getMonitorStats(id, params, { client: this.client });
  }
  searchMonitorRequestLogs(id: SearchMonitorRequestLogsPathParams['id'], data: SearchMonitorRequestLogsMutationRequest) {
    return searchMonitorRequestLogs(id, data, { client: this.client });
  }
  acknowledgeIncident(id: AcknowledgeIncidentPathParams['id'], data?: AcknowledgeIncidentMutationRequest) {
    return acknowledgeIncident(id, data, { client: this.client });
  }
}
